import { render, staticRenderFns } from "./textUpload1.vue?vue&type=template&id=6d3c3a82&scoped=true"
import script from "./textUpload1.vue?vue&type=script&lang=js"
export * from "./textUpload1.vue?vue&type=script&lang=js"
import style0 from "./textUpload1.vue?vue&type=style&index=0&id=6d3c3a82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c3a82",
  null
  
)

export default component.exports